import { render, staticRenderFns } from "./InternetPlansHead.vue?vue&type=template&id=4e153525&scoped=true&"
import script from "./InternetPlansHead.vue?vue&type=script&lang=js&"
export * from "./InternetPlansHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e153525",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
